import React from 'react';
import { observer } from 'mobx-react-lite';
import { TopBar } from '../../components/TopBar/TopBar';
import { ProjectList } from '../../components/ProjectList/ProjectList';
import { ProgressDetailViewModel } from '../../viewModels/ProgressDetailViewModel';
import '../../styles/section.css';
import './ProgressDetailView.css';

interface Props {
  viewModel: ProgressDetailViewModel;
  onBack: () => void;
  onProjectClick?: (projectId: string) => void;
}

const placeholder = '/placeholder.svg';

export const ProgressDetailView: React.FC<Props> = observer(({ viewModel, onBack, onProjectClick }) => {
  const { project, progress, loading, error } = viewModel;

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '';
    return dateStr.length >= 10 ? dateStr.slice(0, 10) : dateStr;
  };

  const handleProjectClick = (project: any) => {
    onProjectClick?.(project.id);
  };

  return (
    <div className="pdg-page">
      <TopBar title="进展报告" showBack onBack={onBack} />

      {loading && <div className="pdg-loading">加载中...</div>}
      {error && <div className="pdg-error">{error}</div>}

      {!loading && progress && (
        <>
          {project && (
            <div className="pdg-project-list-wrapper">
              <ProjectList
                projects={[project]}
                onItemClick={handleProjectClick}
              />
            </div>
          )}

          <div className="pdg-content-section">
            <div className="section-header">
              <h2>进展报告</h2>
            </div>

            <div className="pdg-header">
              <div className="pdg-title">{progress.title}</div>
              <div className="pdg-date">{formatDate(progress.progressDate)}</div>
            </div>
            <div
              className="pdg-content"
              dangerouslySetInnerHTML={{ __html: progress.content || '暂无内容' }}
            />
          </div>
        </>
      )}
    </div>
  );
});


